const {
  REACT_APP_API_BASE_URL,
  REACT_APP_STREAMING_HOST,
  REACT_APP_STREAMING_INFO_URL,
  REACT_APP_PLAY_PREVIEW_BASE_URL,
  REACT_APP_LIVESTREAM_RTMP_BASE_URL,
} = process.env;

const ensureEnv = (value, name) => {
  if (!value) {
    throw new Error(`Missing required environment variable ${name}`);
  }
  return value;
};

export const API_BASE_URL = ensureEnv(
  REACT_APP_API_BASE_URL,
  "REACT_APP_API_BASE_URL"
);

export const STREAMING_HOST = ensureEnv(
  REACT_APP_STREAMING_HOST,
  "REACT_APP_STREAMING_HOST"
);

export const STREAMING_INFO_URL = ensureEnv(
  REACT_APP_STREAMING_INFO_URL,
  "REACT_APP_STREAMING_INFO_URL"
);

export const PLAY_PREVIEW_BASE_URL = ensureEnv(
  REACT_APP_PLAY_PREVIEW_BASE_URL,
  "REACT_APP_PLAY_PREVIEW_BASE_URL"
);

export const LIVESTREAM_RTMP_BASE_URL = ensureEnv(
  REACT_APP_LIVESTREAM_RTMP_BASE_URL,
  "REACT_APP_LIVESTREAM_RTMP_BASE_URL"
);
